export const promises = {}

export const getPromise = modalId => {
  if (promises[modalId]) {
    return promises[modalId]
  }
  console.error('Promise not found')
  return null
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/ModalPromises.js